import { all, fork } from "redux-saga/effects";
import examSaga from "../exam/examSaga";
import analyticsSaga from "../exam_analytics/analyticsSaga";
import aitsSaga from "../aits/aitsSaga";

export default function* rootSaga() {
  yield all([fork(examSaga), fork(analyticsSaga),fork(aitsSaga)]);
}
